<lib-pick-list
  [formControl]="this.formControl"
  [formlyAttributes]="this.field"
  [ngClass]="{
    'ng-dirty ng-invalid p-invalid': this.showError
  }"
  [source]="(this.props.options | formlySelectOptions: this.field | async)!"
  [scrollHeight]="this.props.scrollHeight || '500px'"></lib-pick-list>
